const getURL = location.pathname.indexOf("default.aspx");

$(document).ready(function () {
  if (getURL >= 0 || location.pathname == "/") {
    window.location = ticketPortalHome;
  }
  createBurgerIcon();
  changeWeatherFormat();
  $(".generalmessage").prependTo("header");
  $(".header-logo").attr("href", "" + headerLogo);
  $(".afterContent .footer-logo").attr("href", "" + footerLogo);
});

// Function for weather format

function changeWeatherFormat() {
  setInterval(function () {
    let str = $("#weatherBugDescription").text();
    let weatherBugSet = $("#weatherBugWidget").hasClass("weatherBugSet");
    if (weatherBugSet || str == "") return;
    $("#weatherBugWidget").addClass("weatherBugSet");
    let findSpace = str.lastIndexOf(" ");
    let stringLength = str.length;
    let res = str.substring(findSpace, stringLength);
    let start = str.substring(0, findSpace);
    $("#weatherBugDescription").html(
      '<span class="weatherDescriptive">' + start + "</span>" + res
    );
    $("#weatherBugWidget").css("opacity", 1);
  }, 1000);
}

// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $(".header .mobile-nav-toggle").append("<span class='burger-bar'></span>");
  });
}
